// extracted by mini-css-extract-plugin
export var category = "_ky-9";
export var categoryHeader = "_ky-e";
export var container = "_ky-0";
export var group = "_ky-a";
export var groupItems = "_ky-f";
export var groupSeparator = "_ky-j";
export var loading = "_ky-1";
export var noResults = "_ky-3";
export var placeholder = "_ky-2";
export var resultContent = "_ky-5";
export var resultIcon = "_ky-c";
export var resultItem = "_ky-g";
export var resultMeta = "_ky-8";
export var resultSubtitle = "_ky-7";
export var resultSuffix = "_ky-i";
export var resultTitle = "_ky-6";
export var resultsList = "_ky-4";
export var searchGroup = "_ky-d";
export var selected = "_ky-h";
export var subgroup = "_ky-b";